import { Badge } from '@/components/data-display/Badge';
import { SCREENING_STATUS_LABELS, SCREENING_BADGE_VARIANT } from './types';

interface ScreeningBadgeProps {
  screeningStatusId: number | null | undefined;
}

export function ScreeningBadge({ screeningStatusId }: ScreeningBadgeProps) {
  return (
    <Badge
      variant={
        screeningStatusId != null
          ? (SCREENING_BADGE_VARIANT[screeningStatusId] ?? 'default')
          : 'default'
      }
    >
      {screeningStatusId != null
        ? (SCREENING_STATUS_LABELS[screeningStatusId] ?? `Status ${screeningStatusId}`)
        : 'N/A'}
    </Badge>
  );
}
